<template>
  <base-wrapper :loading="loadingArticles || form.loading || deleteConfirm.loading">
    <div class="space-y-4">
      <div class="flex items-center justify-end space-x-2">
        <base-button @click="onCreate" type="button">
          <Icon icon="heroicons:plus-20-solid" class="h-5 w-5" />
          Tambah Berita
        </base-button>
      </div>
      <datatable
        :total="articles.meta.page.total"
        :perPage="articles.meta.page.perPage"
        :currentPage="articles.meta.page.currentPage"
        :columns="[
          { id: 'title', name: 'Judul' },
          { id: 'article', name: 'Kategori' },
          { id: 'date', name: 'Tanggal' },
          { id: 'action', name: 'Aksi' },
        ]"
        @pagechanged="onPageChange"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="article in articles.data"
            :key="article.id"
            :class="[classes.tr, 'bg-white']"
          >
            <td :class="classes.td">{{ article.attributes.title }}</td>
            <td :class="classes.td">{{ article.attributes.category_name }}</td>
            <td :class="classes.td">{{ article.attributes.createdAt | formatDate }}</td>
            <td :class="[classes.td]">
              <div class="flex gap-1">
                <button
                  class="flex h-8 w-8 items-center justify-center rounded-lg hover:bg-gray-100"
                  @click="onEdit(article)"
                >
                  <Icon icon="heroicons:pencil-square-solid" class="w-4 h-4" />
                </button>
                <button
                  class="flex h-8 w-8 items-center justify-center rounded-lg hover:bg-gray-100"
                  @click="onDelete(article)"
                >
                  <Icon icon="heroicons:trash-solid" class="w-4 h-4" />
                </button>
              </div>
            </td>
          </tr>
        </template>
      </datatable>
    </div>

    <base-modal
      :showing="form.visible"
      @close="form.visible = false"
    >
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <div>
            <h3 class="text-lg font-bold leading-6 text-gray-900">
              {{ form.type === 'create' ? 'Tambah Berita' : 'Edit Berita' }}
            </h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">
              {{ form.type === 'create' ? 'Tambah Berita Baru' : 'Edit Berita' }}
            </p>
          </div>
        </div>
      </div>
      <form
        class="mt-6 space-y-4 border-t border-gray-200 pt-6"
        @submit.prevent="onSubmitForm"
      >
        <base-input
          label="Judul Berita"
          :shadow="false"
          fullwidth
          placeholder="Judul Berita"
          type="text"
          required
          v-model="form.title"
        />
        <base-input
          label="Kategori Berita"
          :shadow="false"
          fullwidth
          required
        >
          <ArticleCategorySelectSearch fullwidth :shadow="false" v-model="form.category" />
        </base-input>
        <base-input
          label="Konten Berita"
          tag="textarea"
          :shadow="false"
          fullwidth
          placeholder="Konten Berita"
          rows="5"
          required
          v-model="form.content"
        />
        <base-input
          label="Thumbnail"
          :shadow="false"
          fullwidth
          type="file"
          :required="form.type === 'create'"
          @change="onChangeImage"
        >
          <template v-if="form.type === 'edit'" #append>
            <p class="mt-1 text-xs text-gray-500">Kosongkan jika tidak diubah</p>
          </template>
        </base-input>
        <div class="space-x-2">
          <base-button color="white" type="button" @click="form.visible = false"
            >Batal</base-button
          >
          <base-button>Simpan</base-button>
        </div>
      </form>
    </base-modal>

    <base-confirm
      :visible="deleteConfirm.visible"
      title="Hapus Berita"
      message="Apakah anda yakin ingin menghapus berita ini?"
      icon-type="badge"
      @close="deleteConfirm.visible = false"
      @confirmed="onConfirmDelete"
    />
  </base-wrapper>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import { requestMixin } from '@/mixins/request/request';
import BaseModal from '../../../../components/base/BaseModal.vue';
import { mapActions } from 'vuex';
import BaseConfirm from '../../../../components/base/BaseConfirm.vue';
import ArticleCategorySelectSearch from '../../../../components/article/ArticleCategorySelectSearch.vue';

export default {
  name: 'Home',
  mixins: [requestMixin],
  components: {
    BaseButton,
    BaseModal,
    BaseConfirm,
    ArticleCategorySelectSearch
  },
  data() {
    return {
      loadingArticles: false,
      articles: {
        data: [],
        meta: {
          page: {},
        },
      },
      form: {
        visible: false,
        loading: false,
        type: 'create',
        title: null,
        content: null,
        category: null,
        image: null,
        editId: null
      },
      deleteConfirm: {
        visible: false,
        loading: false,
        id: null
      }
    };
  },
  created() {
    this.loadArticles();
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    onPageChange(page) {
      this.loadArticles({
        'page[number]': page
      });
    },
    onCreate() {
      this.form.type = 'create'
      this.form.title = null
      this.form.content = null
      this.form.category = null
      this.form.image = null
      this.form.editId = null
      this.form.visible = true;
    },
    onEdit(article) {
      const category = this.getSingleIncluded(this.articles, article.relationships.category.data.id)

      this.form.type = 'edit'
      this.form.title = article.attributes.title
      this.form.content = article.attributes.content
      this.form.category = {
        id: category.id,
        attributes: {
          name: category.attributes.name
        }
      }
      this.form.image = null
      this.form.editId = article.id
      this.form.visible = true;
    },
    onDelete(article) {
      this.deleteConfirm.id = article.id
      this.deleteConfirm.visible = true
    },
    onChangeImage(e) {
      if (e.target.files.length > 0) {
        this.form.image = e.target.files[0]
      } else {
        this.form.image = null
      }
    },
    async onConfirmDelete() {
      this.deleteConfirm.loading = true;

      const [, error] = await this.request(`/api/v1/articles/${this.deleteConfirm.id}`, {
        method: 'delete'
      });

      if (!error) {
        this.deleteConfirm.visible = false;
        this.loadArticles();
      } else {
        this.createAlert({
          data: error.message,
          status: 'error',
        });
      }

      this.deleteConfirm.loading = false;
    },
    async onSubmitForm() {
      this.form.loading = true;

      const [res, error] = await this.request(this.form.type === 'create' ? '/api/v1/articles' : `/api/v1/articles/${this.form.editId}`, {
        method: this.form.type === 'create' ? 'post' : 'patch',
        data: {
          data: {
            type: 'articles',
            ...(this.form.type === 'create' ? {} : { id: this.form.editId }),
            attributes: {
              title: this.form.title,
              content: this.form.content,
            },
            relationships: {
              category: {
                data: {
                  type: 'article-categories',
                  id: this.form.category?.id
                }
              }
            }
          },
        },
      });

      if (!error) {
        if (this.form.image) {
          await this.uploadImage(res.data.id)
        }

        this.form.visible = false;

        this.loadArticles();
      } else {
        this.createAlert({
          data: error.message,
          status: 'error',
        });
      }

      this.form.loading = false;
    },
    async loadArticles(params) {
      this.loadingArticles = true;

      const [res, err] = await this.request('/api/v1/articles', {
        params: {
          'page[size]': 5,
          'sort': '-id',
          'include': 'category',
          ...params,
        },
      });

      if (!err) {
        this.articles = res;
      }

      this.loadingArticles = false;
    },
    async uploadImage(articleId) {
      const formData = new FormData();

      formData.append('image', this.form.image);
        
      await this.request(`/api/v1/articles/${articleId}/-actions/upload-image`, 
        {
          method: 'post',
          data: formData,
        }
      )
    }
  },
};
</script>
